// removed by extract-text-webpack-plugin
module.exports = {"roundBorder":"WirelessInsurance__roundBorder","type-base":"WirelessInsurance__type-base","typeBase":"WirelessInsurance__type-base","mobileView":"WirelessInsurance__mobileView","up-al-margin":"WirelessInsurance__up-al-margin","upAlMargin":"WirelessInsurance__up-al-margin"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessInsurance/WirelessInsuarance.scss
// module id = 2307
// module chunks = 8